var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "price-inventory-normal-container" },
    [
      _vm.tableVisible
        ? _c(
            "el-table",
            {
              staticStyle: { width: "fit-content", "margin-top": "20px" },
              attrs: {
                data: _vm.specTabData,
                "span-method": _vm.objectSpanMethod,
                border: ""
              }
            },
            [
              _c("el-table-column", {
                attrs: { label: "规格图片", width: "140" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c(
                            "el-upload",
                            {
                              attrs: {
                                action:
                                  _vm.env.VUE_APP_fileserver +
                                  "persistentUpload",
                                "show-file-list": false,
                                "on-success": function(res) {
                                  return _vm.uploadSuccess(res, scope)
                                },
                                "before-upload": _vm.uploadBefore
                              }
                            },
                            [
                              scope.row.skuPicUrl
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "el-upload-list--picture-card"
                                    },
                                    [
                                      _c("img", {
                                        staticClass: "skuPic",
                                        attrs: { src: scope.row.skuPicUrl }
                                      }),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "el-upload-list__item-actions"
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "el-upload-list__item-delete",
                                              on: {
                                                click: function($event) {
                                                  $event.stopPropagation()
                                                  scope.row.skuPicUrl = ""
                                                }
                                              }
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "el-icon-delete"
                                              })
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                : _c("i", {
                                    staticClass:
                                      "el-icon-plus skuPic-uploader-icon"
                                  })
                            ]
                          )
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  2118030905
                )
              }),
              _vm._l(_vm.dynamicColumn, function(column) {
                return _c("el-table-column", {
                  key: column.prop,
                  attrs: {
                    prop: column.prop,
                    label: column.label,
                    width: "140"
                  }
                })
              }),
              _vm.isOA
                ? _c("el-table-column", {
                    attrs: { label: "代号名称", prop: "qlwName", width: "140" }
                  })
                : _vm._e(),
              _c("el-table-column", {
                attrs: { width: "150" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "header",
                      fn: function() {
                        return [
                          _c("span", [
                            _c("span", { staticClass: "xingTips" }, [
                              _vm._v("*")
                            ]),
                            _vm._v("销售单位  ")
                          ]),
                          _c(
                            "el-popover",
                            {
                              attrs: {
                                placement: "top",
                                width: "180",
                                trigger: "click"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "reference",
                                    fn: function() {
                                      return [
                                        !_vm.isOA
                                          ? _c("i", {
                                              staticClass:
                                                "el-icon-edit-outline"
                                            })
                                          : _vm._e()
                                      ]
                                    },
                                    proxy: true
                                  }
                                ],
                                null,
                                false,
                                3003796565
                              ),
                              model: {
                                value: _vm.batchUnitObj.batchUnitShow,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.batchUnitObj,
                                    "batchUnitShow",
                                    $$v
                                  )
                                },
                                expression: "batchUnitObj.batchUnitShow"
                              }
                            },
                            [
                              _c(
                                "div",
                                [
                                  _c("h4", [_vm._v("批量修改销售单位")]),
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { "margin-top": "7px" },
                                      attrs: {
                                        filterable: "",
                                        size: "mini",
                                        placeholder: "请选择销售单位"
                                      },
                                      on: { change: _vm.bacthUnitSelectChange },
                                      model: {
                                        value: _vm.batchUnitObj.batchUnitCode,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.batchUnitObj,
                                            "batchUnitCode",
                                            $$v
                                          )
                                        },
                                        expression: "batchUnitObj.batchUnitCode"
                                      }
                                    },
                                    _vm._l(_vm.unitsList, function(unitItem) {
                                      return _c("el-option", {
                                        key: unitItem.unitsCode,
                                        attrs: {
                                          label: unitItem.unitsName,
                                          value: unitItem.unitsCode
                                        }
                                      })
                                    }),
                                    1
                                  ),
                                  _vm.batchUnitObj.batchUnitShowError
                                    ? _c("p", { staticClass: "batchTips" }, [
                                        _vm._v("请选择销售单位")
                                      ])
                                    : _vm._e(),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "bottomBtnsBox text-center"
                                    },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: { size: "mini" },
                                          on: {
                                            click: function($event) {
                                              _vm.batchUnitObj.batchUnitShow = false
                                            }
                                          }
                                        },
                                        [_vm._v("取消")]
                                      ),
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            size: "mini",
                                            type: "primary"
                                          },
                                          on: { click: _vm.batchUnitSure }
                                        },
                                        [_vm._v("确定")]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ]
                          ),
                          _c("div", { staticClass: "fb-normal f12" }, [
                            _vm._v("按销售单位下单结算")
                          ])
                        ]
                      },
                      proxy: true
                    },
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                filterable: "",
                                placeholder: "销售单位"
                              },
                              on: {
                                change: function($event) {
                                  return _vm.unitSelectChange($event, scope.row)
                                }
                              },
                              model: {
                                value: scope.row.skuUnit,
                                callback: function($$v) {
                                  _vm.$set(scope.row, "skuUnit", $$v)
                                },
                                expression: "scope.row.skuUnit"
                              }
                            },
                            _vm._l(_vm.unitsList, function(unitItem) {
                              return _c("el-option", {
                                key: unitItem.unitsCode,
                                attrs: {
                                  label: unitItem.unitsName,
                                  value: unitItem.unitsCode
                                }
                              })
                            }),
                            1
                          )
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  4070998659
                )
              }),
              _vm.shopConfig &&
              _vm.shopConfig.funcSettingMap.is_off_stand != "0"
                ? _c("el-table-column", {
                    attrs: { width: "320" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "header",
                          fn: function() {
                            return [
                              _c("span", [_vm._v("计量单位  ")]),
                              _c(
                                "el-popover",
                                {
                                  attrs: {
                                    placement: "top",
                                    width: "300",
                                    trigger: "click"
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "reference",
                                        fn: function() {
                                          return [
                                            _c("i", {
                                              staticClass:
                                                "el-icon-edit-outline"
                                            })
                                          ]
                                        },
                                        proxy: true
                                      }
                                    ],
                                    null,
                                    false,
                                    2987130303
                                  ),
                                  model: {
                                    value: _vm.batchUnitRatioObj.unitRatioShow,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.batchUnitRatioObj,
                                        "unitRatioShow",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "batchUnitRatioObj.unitRatioShow"
                                  }
                                },
                                [
                                  _c("div", [
                                    _c("h4", [_vm._v("批量修改计量单位")]),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "flex items-center",
                                        staticStyle: { "margin-top": "7px" }
                                      },
                                      [
                                        _c("el-input", {
                                          staticClass: "mar10-r flex-shrink",
                                          staticStyle: { width: "120px" },
                                          attrs: {
                                            size: "mini",
                                            placeholder: "请填写换算值",
                                            oninput:
                                              "value=value.replace(/[^\\d^\\.]+/g,'').replace('.','$#$').replace(/\\./g,'').replace('$#$','.').replace(/^(\\-)*(\\d+)\\.(\\d\\d).*$/,'$1$2.$3')"
                                          },
                                          model: {
                                            value: _vm.batchUnitRatioObj.ratio,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.batchUnitRatioObj,
                                                "ratio",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "batchUnitRatioObj.ratio"
                                          }
                                        }),
                                        _c(
                                          "el-select",
                                          {
                                            staticStyle: { width: "100px" },
                                            attrs: {
                                              clearable: "",
                                              filterable: "",
                                              placeholder: "计量单位",
                                              size: "mini"
                                            },
                                            model: {
                                              value: _vm.batchUnitRatioObj.unit,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.batchUnitRatioObj,
                                                  "unit",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "batchUnitRatioObj.unit"
                                            }
                                          },
                                          _vm._l(_vm.unitsList, function(
                                            unitItem
                                          ) {
                                            return _c("el-option", {
                                              key: unitItem.unitsCode,
                                              attrs: {
                                                label: unitItem.unitsName,
                                                value: unitItem.unitsCode
                                              }
                                            })
                                          }),
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "bottomBtnsBox" },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: { size: "mini" },
                                            on: {
                                              click: function($event) {
                                                _vm.batchUnitRatioObj.unitRatioShow = false
                                              }
                                            }
                                          },
                                          [_vm._v("取消")]
                                        ),
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              size: "mini",
                                              type: "primary"
                                            },
                                            on: {
                                              click: _vm.batchUnitRatioSure
                                            }
                                          },
                                          [_vm._v("确定")]
                                        )
                                      ],
                                      1
                                    )
                                  ])
                                ]
                              )
                            ]
                          },
                          proxy: true
                        },
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "div",
                                { staticClass: "flex nowrap items-center" },
                                [
                                  _c("div", { staticClass: "pad5-r" }, [
                                    _vm._v("每")
                                  ]),
                                  _c("el-input", {
                                    staticClass: "mar10-r flex-shrink",
                                    staticStyle: { width: "120px" },
                                    attrs: {
                                      placeholder: "请填写换算值",
                                      oninput:
                                        "value=value.replace(/[^\\d^\\.]+/g,'').replace('.','$#$').replace(/\\./g,'').replace('$#$','.').replace(/^(\\-)*(\\d+)\\.(\\d\\d).*$/,'$1$2.$3')"
                                    },
                                    model: {
                                      value: scope.row.unitRatio,
                                      callback: function($$v) {
                                        _vm.$set(scope.row, "unitRatio", $$v)
                                      },
                                      expression: "scope.row.unitRatio"
                                    }
                                  }),
                                  _c(
                                    "el-select",
                                    {
                                      staticClass: "flex-shrink",
                                      staticStyle: { width: "80px" },
                                      attrs: {
                                        filterable: "",
                                        placeholder: "计量单位"
                                      },
                                      model: {
                                        value: scope.row.sUnit,
                                        callback: function($$v) {
                                          _vm.$set(scope.row, "sUnit", $$v)
                                        },
                                        expression: "scope.row.sUnit"
                                      }
                                    },
                                    _vm._l(_vm.unitsList, function(unitItem) {
                                      return _c("el-option", {
                                        key: unitItem.unitsCode,
                                        attrs: {
                                          label: unitItem.unitsName,
                                          value: unitItem.unitsCode
                                        }
                                      })
                                    }),
                                    1
                                  ),
                                  _c("div", { staticClass: "pad5-l" }, [
                                    _vm._v(
                                      "≈1" +
                                        _vm._s(
                                          scope.row &&
                                            scope.row.spec &&
                                            scope.row.spec.split("/")[1]
                                        )
                                    )
                                  ])
                                ],
                                1
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      953747320
                    )
                  })
                : _vm._e(),
              !_vm.isOA
                ? _c("el-table-column", {
                    attrs: { width: "190" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "header",
                          fn: function() {
                            return [
                              _c("span", [
                                _c("span", { staticClass: "xingTips" }, [
                                  _vm._v("*")
                                ]),
                                _vm._v("商品价格  ")
                              ]),
                              _c(
                                "el-popover",
                                {
                                  attrs: {
                                    placement: "top",
                                    width: "280",
                                    trigger: "click"
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "reference",
                                        fn: function() {
                                          return [
                                            _c("i", {
                                              staticClass:
                                                "el-icon-edit-outline"
                                            })
                                          ]
                                        },
                                        proxy: true
                                      }
                                    ],
                                    null,
                                    false,
                                    2987130303
                                  ),
                                  model: {
                                    value: _vm.batchPriceObj.batchPriceShow,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.batchPriceObj,
                                        "batchPriceShow",
                                        $$v
                                      )
                                    },
                                    expression: "batchPriceObj.batchPriceShow"
                                  }
                                },
                                [
                                  _c("div", [
                                    _c("h4", [_vm._v("批量修改价格")]),
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          display: "flex",
                                          "margin-top": "7px",
                                          "margin-left": "7px"
                                        }
                                      },
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            staticStyle: { width: "100px" },
                                            attrs: { size: "mini" },
                                            model: {
                                              value:
                                                _vm.batchPriceObj
                                                  .batchSelectType,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.batchPriceObj,
                                                  "batchSelectType",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "batchPriceObj.batchSelectType"
                                            }
                                          },
                                          _vm._l(
                                            _vm.batchPriceOptions,
                                            function(selectOptions) {
                                              return _c("el-option", {
                                                key: selectOptions.id,
                                                attrs: {
                                                  label: selectOptions.name,
                                                  value: selectOptions.id
                                                }
                                              })
                                            }
                                          ),
                                          1
                                        ),
                                        _c("el-input", {
                                          staticStyle: {
                                            width: "150px",
                                            "margin-left": "10px"
                                          },
                                          attrs: {
                                            size: "mini",
                                            type: "number",
                                            min: 0,
                                            placeholder: "商品价格"
                                          },
                                          on: {
                                            input: _vm.batchPriceInput,
                                            change: _vm.batchPriceChange
                                          },
                                          model: {
                                            value: _vm.batchPriceObj.batchPrice,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.batchPriceObj,
                                                "batchPrice",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "batchPriceObj.batchPrice"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm.batchPriceObj.batchPriceNullError ||
                                    _vm.batchPriceObj.batchPriceFuError
                                      ? _c("p", { staticClass: "batchTips" }, [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(
                                                _vm.batchPriceObj
                                                  .batchPriceNullError
                                                  ? "请填写价格"
                                                  : "价格不可为负数"
                                              ) +
                                              "\n            "
                                          )
                                        ])
                                      : _vm._e(),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "text-center bottomBtnsBox"
                                      },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: { size: "mini" },
                                            on: {
                                              click: function($event) {
                                                _vm.batchPriceObj.batchPriceShow = false
                                              }
                                            }
                                          },
                                          [_vm._v("取消")]
                                        ),
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              size: "mini",
                                              type: "primary"
                                            },
                                            on: { click: _vm.batchPriceSure }
                                          },
                                          [_vm._v("确定")]
                                        )
                                      ],
                                      1
                                    )
                                  ])
                                ]
                              )
                            ]
                          },
                          proxy: true
                        },
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c("el-input", {
                                attrs: {
                                  type: "number",
                                  min: 0,
                                  placeholder: "商品价格",
                                  disabled:
                                    _vm.isOA || (!_vm.isOA && !_vm.cateModel)
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.skuPriceInput(scope.row)
                                  },
                                  change: function($event) {
                                    return _vm.skuPriceChange(scope.row)
                                  }
                                },
                                model: {
                                  value: scope.row.price,
                                  callback: function($$v) {
                                    _vm.$set(scope.row, "price", $$v)
                                  },
                                  expression: "scope.row.price"
                                }
                              })
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      1594971322
                    )
                  })
                : _vm._e(),
              _c("el-table-column", {
                attrs: { width: "190" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "header",
                      fn: function() {
                        return [
                          _c("span", [_vm._v("起订量  ")]),
                          _vm.cateModel
                            ? _c(
                                "el-popover",
                                {
                                  attrs: {
                                    placement: "top",
                                    width: "230",
                                    trigger: "click"
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "reference",
                                        fn: function() {
                                          return [
                                            _c("i", {
                                              staticClass:
                                                "el-icon-edit-outline"
                                            })
                                          ]
                                        },
                                        proxy: true
                                      }
                                    ],
                                    null,
                                    false,
                                    2987130303
                                  ),
                                  model: {
                                    value:
                                      _vm.batchMinOrderQuantityObj
                                        .batchMinOrderQuantityShow,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.batchMinOrderQuantityObj,
                                        "batchMinOrderQuantityShow",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "batchMinOrderQuantityObj.batchMinOrderQuantityShow"
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    [
                                      _c("h4", [_vm._v("批量修改起订量")]),
                                      _c("el-input", {
                                        attrs: {
                                          size: "mini",
                                          type: "number",
                                          min: 0,
                                          placeholder:
                                            _vm.shopConfig &&
                                            _vm.shopConfig.goodsAmountDigit ==
                                              "0"
                                              ? "请输入1以上的整数"
                                              : "请输入起订量"
                                        },
                                        on: {
                                          input: _vm.batchMinOrderQuantityInput
                                        },
                                        model: {
                                          value:
                                            _vm.batchMinOrderQuantityObj
                                              .batchMinOrderQuantity,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.batchMinOrderQuantityObj,
                                              "batchMinOrderQuantity",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "batchMinOrderQuantityObj.batchMinOrderQuantity"
                                        }
                                      }),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "flex justify-center pad10-t"
                                        },
                                        [
                                          _c(
                                            "el-button",
                                            {
                                              attrs: { size: "mini" },
                                              on: {
                                                click: function($event) {
                                                  _vm.batchMinOrderQuantityObj.batchMinOrderQuantityShow = false
                                                  _vm.batchMinOrderQuantityObj.batchMinOrderQuantity =
                                                    ""
                                                }
                                              }
                                            },
                                            [_vm._v("取消")]
                                          ),
                                          _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                size: "mini",
                                                type: "primary"
                                              },
                                              on: {
                                                click:
                                                  _vm.batchMinOrderQuantitySure
                                              }
                                            },
                                            [_vm._v("确定")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            : _vm._e()
                        ]
                      },
                      proxy: true
                    },
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c("el-input", {
                            attrs: {
                              type: "number",
                              min: 0,
                              max: 99999999,
                              placeholder:
                                _vm.shopConfig &&
                                _vm.shopConfig.goodsAmountDigit == "0"
                                  ? "请输入1以上的整数"
                                  : "请输入起订量",
                              disabled: !_vm.cateModel
                            },
                            on: {
                              input: function($event) {
                                return _vm.skuMinOrderQuantityInput(scope.row)
                              }
                            },
                            model: {
                              value: scope.row.minOrderQuantity,
                              callback: function($$v) {
                                _vm.$set(scope.row, "minOrderQuantity", $$v)
                              },
                              expression: "scope.row.minOrderQuantity"
                            }
                          })
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  1103644259
                )
              }),
              _vm.isOA
                ? _c("el-table-column", {
                    attrs: { label: "库存方式", width: "140" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "header",
                          fn: function() {
                            return [
                              _c(
                                "el-tooltip",
                                {
                                  attrs: { effect: "dark", placement: "top" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "content",
                                        fn: function() {
                                          return [
                                            _vm._v(
                                              "\n            不启用库存:买家下单不会受到库存数量限制! "
                                            ),
                                            _c("br"),
                                            _vm._v(
                                              "\n            启用售卖库存:用户下单,根据库存数量进行判断!"
                                            ),
                                            _c("br"),
                                            _vm._v(
                                              "\n            启用管理库存:用户下单,根据库存数量进行判断,用户下单不会减少系统管理库存!"
                                            ),
                                            _c("br")
                                          ]
                                        },
                                        proxy: true
                                      }
                                    ],
                                    null,
                                    false,
                                    3037195508
                                  )
                                },
                                [_c("i", { staticClass: "el-icon-info" })]
                              ),
                              _vm._v("\n         库存方式\n      ")
                            ]
                          },
                          proxy: true
                        },
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-select",
                                {
                                  on: {
                                    change: function($event) {
                                      return _vm.stockSelectChange(
                                        $event,
                                        scope.row
                                      )
                                    }
                                  },
                                  model: {
                                    value: scope.row.stockType,
                                    callback: function($$v) {
                                      _vm.$set(scope.row, "stockType", $$v)
                                    },
                                    expression: "scope.row.stockType"
                                  }
                                },
                                _vm._l(_vm.stockTypeArr, function(stockItem) {
                                  return _c("el-option", {
                                    key: stockItem.stockType,
                                    attrs: {
                                      label: stockItem.stockTypeName,
                                      value: stockItem.stockType
                                    }
                                  })
                                }),
                                1
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      986562730
                    )
                  })
                : _vm._e(),
              _c("el-table-column", {
                attrs: { width: "140" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "header",
                      fn: function() {
                        return [
                          _c("span", [
                            _c("span", { staticClass: "xingTips" }, [
                              _vm._v("*")
                            ]),
                            _vm._v("商品库存  ")
                          ]),
                          _c(
                            "el-popover",
                            {
                              attrs: {
                                placement: "top",
                                width: "230",
                                trigger: "click"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "reference",
                                    fn: function() {
                                      return [
                                        !_vm.isOA
                                          ? _c("i", {
                                              staticClass:
                                                "el-icon-edit-outline"
                                            })
                                          : _vm._e()
                                      ]
                                    },
                                    proxy: true
                                  }
                                ],
                                null,
                                false,
                                3003796565
                              ),
                              model: {
                                value: _vm.batchStockObj.batchStockShow,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.batchStockObj,
                                    "batchStockShow",
                                    $$v
                                  )
                                },
                                expression: "batchStockObj.batchStockShow"
                              }
                            },
                            [
                              _c("div", [
                                _c("h4", [_vm._v("批量修改库存")]),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      "margin-top": "7px"
                                    }
                                  },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "100px" },
                                        attrs: { size: "mini" },
                                        model: {
                                          value:
                                            _vm.batchStockObj.batchSelectType,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.batchStockObj,
                                              "batchSelectType",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "batchStockObj.batchSelectType"
                                        }
                                      },
                                      _vm._l(_vm.batchStockOptions, function(
                                        selectOptions
                                      ) {
                                        return _c("el-option", {
                                          key: selectOptions.id,
                                          attrs: {
                                            label: selectOptions.name,
                                            value: selectOptions.id
                                          }
                                        })
                                      }),
                                      1
                                    ),
                                    _c("el-input", {
                                      staticStyle: {
                                        width: "100px",
                                        "margin-left": "10px"
                                      },
                                      attrs: {
                                        size: "mini",
                                        maxlength: "9",
                                        placeholder: "商品库存",
                                        oninput:
                                          "value=value.replace(/[^\\d]/g,'')"
                                      },
                                      on: {
                                        input: _vm.batchStockInput,
                                        change: _vm.batchStockChange
                                      },
                                      model: {
                                        value: _vm.batchStockObj.batchStock,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.batchStockObj,
                                            "batchStock",
                                            $$v
                                          )
                                        },
                                        expression: "batchStockObj.batchStock"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm.batchStockObj.batchStockNullError ||
                                _vm.batchStockObj.batchStockFuError
                                  ? _c("p", { staticClass: "batchTips" }, [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.batchStockObj
                                              .batchStockNullError
                                              ? "请填写库存"
                                              : "库存不可为负数"
                                          ) +
                                          "\n            "
                                      )
                                    ])
                                  : _vm._e(),
                                _c(
                                  "div",
                                  { staticClass: "bottomBtnsBox text-center" },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { size: "mini" },
                                        on: {
                                          click: function($event) {
                                            _vm.batchStockObj.batchStockShow = false
                                          }
                                        }
                                      },
                                      [_vm._v("取消")]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          size: "mini",
                                          type: "primary"
                                        },
                                        on: { click: _vm.batchStockSure }
                                      },
                                      [_vm._v("确定")]
                                    )
                                  ],
                                  1
                                )
                              ])
                            ]
                          )
                        ]
                      },
                      proxy: true
                    },
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c("el-input", {
                            attrs: {
                              maxlength: "9",
                              placeholder: "商品库存",
                              oninput: "value=value.replace(/[^\\d]/g,'')",
                              disabled: scope.row.stockType != 1
                            },
                            on: {
                              input: _vm.skuStockInput,
                              change: function($event) {
                                return _vm.skuStockChange(scope.row)
                              }
                            },
                            model: {
                              value: scope.row.stock,
                              callback: function($$v) {
                                _vm.$set(scope.row, "stock", $$v)
                              },
                              expression: "scope.row.stock"
                            }
                          })
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  957810711
                )
              }),
              _vm.shopConfig &&
              _vm.shopConfig.funcSettingMap.is_allow_unreal_sales == "1"
                ? _c("el-table-column", {
                    attrs: { width: "140" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "header",
                          fn: function() {
                            return [
                              _c("span", [_vm._v("虚拟销量  ")]),
                              _c(
                                "el-popover",
                                {
                                  attrs: {
                                    placement: "top",
                                    width: "230",
                                    trigger: "click"
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "reference",
                                        fn: function() {
                                          return [
                                            _c("i", {
                                              staticClass:
                                                "el-icon-edit-outline"
                                            })
                                          ]
                                        },
                                        proxy: true
                                      }
                                    ],
                                    null,
                                    false,
                                    2987130303
                                  ),
                                  model: {
                                    value:
                                      _vm.batchVirtualObj
                                        .batchsalesVolumeUnrealShow,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.batchVirtualObj,
                                        "batchsalesVolumeUnrealShow",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "batchVirtualObj.batchsalesVolumeUnrealShow"
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    [
                                      _c("h4", [_vm._v("批量修改虚拟销量")]),
                                      _c("el-input", {
                                        staticStyle: { "margin-top": "7px" },
                                        attrs: {
                                          size: "mini",
                                          type: "number",
                                          min: 0,
                                          placeholder: "虚拟销量",
                                          oninput:
                                            "value=value.replace(/[^\\d^\\.]+/g,'').replace('.','$#$').replace(/\\./g,'').replace('$#$','').replace(/^(\\-)*(\\d+)\\.(\\d\\d).*$/,'$1$2')"
                                        },
                                        model: {
                                          value:
                                            _vm.batchVirtualObj
                                              .batchsalesVolumeUnreal,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.batchVirtualObj,
                                              "batchsalesVolumeUnreal",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "batchVirtualObj.batchsalesVolumeUnreal"
                                        }
                                      }),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "bottomBtnsBox text-center"
                                        },
                                        [
                                          _c(
                                            "el-button",
                                            {
                                              attrs: { size: "mini" },
                                              on: {
                                                click: function($event) {
                                                  _vm.batchVirtualObj.batchsalesVolumeUnrealShow = false
                                                }
                                              }
                                            },
                                            [_vm._v("取消")]
                                          ),
                                          _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                size: "mini",
                                                type: "primary"
                                              },
                                              on: {
                                                click:
                                                  _vm.batchsalesVolumeUnrealSure
                                              }
                                            },
                                            [_vm._v("确定")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            ]
                          },
                          proxy: true
                        },
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c("el-input", {
                                attrs: {
                                  type: "number",
                                  min: 0,
                                  placeholder: "虚拟销量",
                                  oninput:
                                    "value=value.replace(/[^\\d^\\.]+/g,'').replace('.','$#$').replace(/\\./g,'').replace('$#$','').replace(/^(\\-)*(\\d+)\\.(\\d\\d).*$/,'$1$2')"
                                },
                                model: {
                                  value: scope.row.salesVolumeUnreal,
                                  callback: function($$v) {
                                    _vm.$set(
                                      scope.row,
                                      "salesVolumeUnreal",
                                      $$v
                                    )
                                  },
                                  expression: "scope.row.salesVolumeUnreal"
                                }
                              })
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      2338440420
                    )
                  })
                : _vm._e(),
              _c("el-table-column", {
                attrs: { label: "商品编码", width: "140" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c("el-input", {
                            attrs: { placeholder: "商品编码" },
                            on: { input: _vm.skuRelationNoInput },
                            model: {
                              value: scope.row.relationNo,
                              callback: function($$v) {
                                _vm.$set(scope.row, "relationNo", $$v)
                              },
                              expression: "scope.row.relationNo"
                            }
                          })
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  4028314646
                )
              })
            ],
            2
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }